import { useDotloopComplianceGroupsQuery } from '@client/graphql/__generated__/document-operations';
import { FC, useMemo } from 'react';
import { Select, SelectProps } from '~/services/document/common/Select';

export interface ComplianceStatusSelectOption {
  label?: string;
  value: string;
}

export interface ComplianceStatusSelectProps
  extends SelectProps<ComplianceStatusSelectOption, false> {
  profileId: string;
  complianceGroupId: string;
}

export const ComplianceStatusSelect: FC<ComplianceStatusSelectProps> = ({
  profileId,
  complianceGroupId,
  ...props
}) => {
  const { data, loading } = useDotloopComplianceGroupsQuery({
    variables: {
      filters: {
        profileId,
      },
    },
  });
  const complianceStatuses = useMemo(() => {
    return data?.dotloopComplianceGroups?.find(
      (group) => group.id === complianceGroupId
    )?.complianceStatuses;
  }, [data?.dotloopComplianceGroups, complianceGroupId]);

  const complianceStatusesMap = useMemo(() => {
    return complianceStatuses?.reduce(
      (acc, status) => {
        const statusId = status?.id as string;
        const statusName = status?.name as string;

        if (statusId && statusName) {
          acc[statusId] = statusName;
        }

        return acc;
      },
      {} as Record<string, string>
    );
  }, [complianceStatuses]);

  return (
    <Select
      isClearable
      getOptionLabel={(option) => {
        return complianceStatusesMap?.[option.value] as string;
      }}
      isLoading={loading}
      menuPortalTarget={window.document.body}
      options={complianceStatuses?.map((status) => ({
        label: status?.name as string,
        value: status?.id as string,
      }))}
      placeholder="No Change"
      size="sm"
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      {...props}
    />
  );
};
